module.exports = __webpack_public_path__ + "img/docker.7bcbbab5.png";